(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5019],{

/***/ 19190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(159);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27597);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/** ========== */




var RefundGuarantee = function RefundGuarantee(_ref) {
  var props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _ref);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "flex flex-col items-center justify-center text-center lg:flex-row lg:text-left",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        src: "/assets/icons/refund-guarantee.svg",
        width: 80,
        height: 80
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "mt-4 lg:mt-0 lg:ml-4",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
          className: "text-lg font-semibold",
          children: "Refund Guarantee"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
          className: "text-base font-normal",
          children: "We refund your money in full for services that we cannot deliver."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("em", {
          className: "text-sm font-medium leading-6 text-bbc-brand-500 underline",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            href: "/refund-policy",
            target: "_blank",
            children: "Read our policy"
          })
        })]
      })]
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (RefundGuarantee);
/** ========== */

/***/ }),

/***/ 4330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EbookDownloadSection; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31741);
/* harmony import */ var components_templates_common_post_FormDownloadModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53693);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








function EbookDownloadSection(_ref) {
  var title = _ref.title,
      imgSrc = _ref.imgSrc,
      sectionClass = _ref.sectionClass,
      children = _ref.children,
      dataForm = _ref.dataForm,
      hash = _ref.hash,
      wrapper = _ref.wrapper,
      url = _ref.url;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      showFormDownload = _useState[0],
      setShowFormDownload = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      haveFormDownload = _useState2[0],
      setHaveFormDownload = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (document.getElementById("shortcode_download_form")) {
      setHaveFormDownload(true);
      document.querySelectorAll("#shortcode_download_form .btn").forEach(function (item) {
        item.addEventListener("click", function () {
          setShowFormDownload(true);
        });
      });
    }
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    className: wrapper === null || wrapper === void 0 ? void 0 : wrapper.className,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "row justify-center",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        id: "ebook-download",
        className: "m-auto lg:col-10 lg:px-0",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          text: title,
          className: "bbc-title mb-6 px-5 text-center capitalize lg:mb-10 lg:px-0"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "row flex-col-reverse justify-between lg:flex-row ".concat(sectionClass || ""),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "flex items-center justify-center lg:col-5",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread({
              className: " mt-6 w-full lg:mt-0",
              width: 360,
              height: 515
            }, imgSrc))
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: "lg:col-6",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              children: children
            }), dataForm ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              id: "shortcode_download_form",
              className: "btn mt-6 text-center lg:text-left",
              "data-type-shortcode": dataForm,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                variant: "outline",
                className: "btn rounded-full border border-bbc-primary bg-transparent py-2 px-6 font-semibold text-bbc-primary hover:bg-bbc-primary hover:text-white",
                children: "Download Now"
              })
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
              className: "mt-6 text-center lg:text-left",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                id: hash,
                variant: "outline",
                as: "a",
                href: url,
                children: "Download Now"
              })
            })]
          })]
        }), haveFormDownload && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_templates_common_post_FormDownloadModal__WEBPACK_IMPORTED_MODULE_5__["default"], {
          show: showFormDownload,
          onHide: function onHide() {
            return setShowFormDownload(false);
          },
          typeFormDownload: dataForm
        })]
      })
    })
  });
}

/***/ }),

/***/ 46570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./common/hooks/useResizeScreenModified.js
var useResizeScreenModified = __webpack_require__(77450);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/CheckContent/index.js
var CheckContent = __webpack_require__(36484);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/CardRegistration/index.js



function CardRegistration(_ref) {
  var index = _ref.index,
      item = _ref.item;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mb-6 flex items-center justify-center rounded-full bg-white text-lg font-semibold text-bbc-yellow-500 lg:mb-10",
      style: {
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        width: "58px",
        height: "58px"
      },
      children: index + 1
    }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "mb-4 text-lg font-medium text-bbc-brand-700 lg:mb-6 lg:font-semibold",
      children: item.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "text-bbc-gray",
      children: item.content
    })]
  });
}
// EXTERNAL MODULE: ./components/molecules/FormCountries/index.js
var FormCountries = __webpack_require__(88279);
// EXTERNAL MODULE: ./components/molecules/FormNewsletter/index.js
var FormNewsletter = __webpack_require__(32314);
// EXTERNAL MODULE: ./components/molecules/RefundGuarantee/index.js
var RefundGuarantee = __webpack_require__(19190);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/EbookDownload/index.js
var EbookDownload = __webpack_require__(4330);
// EXTERNAL MODULE: ./components/organisms/Faqs/index.js
var Faqs = __webpack_require__(37768);
// EXTERNAL MODULE: ./components/organisms/OffshoreCompanyRegistration/index.js
var OffshoreCompanyRegistration = __webpack_require__(58720);
// EXTERNAL MODULE: ./components/organisms/PackagesNews/index.js + 1 modules
var PackagesNews = __webpack_require__(30913);
// EXTERNAL MODULE: ./components/organisms/RequiredDocument/index.js
var RequiredDocument = __webpack_require__(95183);
// EXTERNAL MODULE: ./components/organisms/WhatMakeUsDifferent/index.js + 2 modules
var WhatMakeUsDifferent = __webpack_require__(58722);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
;// CONCATENATED MODULE: ./components/templates/hk/company-incorporation/AnyIndustry.js
/* eslint-disable react/jsx-no-target-blank */









function AnyIndustry(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "container",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "py-[100px] ",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
        text: "Company Registration For Any Industry",
        className: "bbc-title mb-6 text-center text-white"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "m-auto w-4/5 text-center text-white",
        children: "Hong Kong has plenty to offer in terms of business opportunities. Let's take a look at what some of the prominent prospects you can look forward to below:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "row hidden lg:flex",
        children: data && data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-10 lg:col-4",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "h-full rounded-3xl bg-white p-7",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: "/assets/icons/".concat(item.icon),
                alt: item.title,
                width: 48,
                height: 48,
                className: "h-12 w-12",
                wrapper: {
                  className: "bg-bbc-brand-100 rounded-3xl p-4 inline-block mb-4"
                }
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mb-4 text-lg font-semibold text-bbc-brand-700",
                children: item.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "",
                children: item.description
              }), item.link && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "mt-1 inline-block font-medium text-bbc-brand-500",
                href: item.link.href,
                target: "_blank",
                rel: "noopener noreferrer",
                children: item.link.text
              })]
            })
          }, index);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "block lg:hidden",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            loop: true,
            autoplay: {
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            },
            className: "mySwiper ",
            modules: [swiper_esm/* Pagination */.tl, swiper_esm/* Autoplay */.pt],
            pagination: {
              el: ".hk-slide-pagination",
              clickable: true,
              bulletClass: "transition-all duration-300 ease-in-out relative inline-block cursor-pointer mx-1 w-2.5 h-2.5 rounded-full bg-white",
              bulletActiveClass: "bg-bbc-secondary-100"
            },
            children: data && data.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                className: " h-auto p-4",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "h-full rounded-3xl bg-white p-7",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                    src: "/assets/icons/".concat(item.icon),
                    alt: item.title,
                    width: 48,
                    height: 48,
                    className: "h-12 w-12",
                    wrapper: {
                      className: "bg-bbc-brand-100 rounded-3xl p-4 inline-block mb-4"
                    }
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "mb-4 text-lg font-semibold text-bbc-brand-700",
                    children: item.title
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "",
                    children: item.description
                  }), item.link && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: "mt-1 inline-block font-medium text-bbc-brand-500",
                    href: item.link.href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: item.link.text
                  })]
                })
              }, index);
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hk-slide-pagination text-center"
        })]
      })]
    })
  });
}
;// CONCATENATED MODULE: ./components/templates/hk/company-incorporation/index.js























var StepSlider = (0,dynamic["default"])(function () {
  return __webpack_require__.e(/* import() */ 8691).then(__webpack_require__.bind(__webpack_require__, 18691));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(18691)];
    },
    modules: ["../components/templates/hk/company-incorporation/index.js -> " + "components/organisms/StepSlider"]
  }
});
var CISlider = (0,dynamic["default"])(function () {
  return __webpack_require__.e(/* import() */ 7527).then(__webpack_require__.bind(__webpack_require__, 17527));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(17527)];
    },
    modules: ["../components/templates/hk/company-incorporation/index.js -> " + "./CISlider"]
  }
});
var NewsSlider = (0,dynamic["default"])(function () {
  return __webpack_require__.e(/* import() */ 5593).then(__webpack_require__.bind(__webpack_require__, 9485));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9485)];
    },
    modules: ["../components/templates/hk/company-incorporation/index.js -> " + "components/organisms/NewsSlider"]
  }
});

var HkCompanyIncorporation = function HkCompanyIncorporation(_ref) {
  var _dataJson$dataHowItWo, _dataJson$dataHowItWo2;

  var data = _ref.data,
      dataJson = _ref.dataJson;
  var country = dataJson.country;
  var swiper = {
    direction: "vertical",
    preloadImages: false,
    lazy: true,
    autoHeight: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    speed: 800,
    fadeEffect: {
      crossFade: true
    },
    virtualTranslate: true,
    effect: "fade",
    mousewheel: true,
    pagination: {
      el: ".bbc-slide-pagination",
      clickable: true,
      bulletClass: "bbc-pagination-bullet block my-1",
      bulletActiveClass: "bbc-pagination-bullet-active h-10 w-2.5"
    },
    slidesPerView: "auto",
    spaceBetween: 0
  };

  var _useState = (0,react.useState)(),
      screen = _useState[0],
      setScreen = _useState[1];

  (0,useResizeScreenModified/* default */.Z)(setScreen);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
      minHeightBanner: "banner-min-h-635",
      breadcrumbs: dataJson.breadcrumbs,
      title: "Company formation <br/>in Hong Kong",
      titleProps: {
        className: "banner-default-title mb-6 lg:mb-10 capitalize",
        textColor: "banner-title-default-color"
      },
      description: "<div class='text-bbc-brand-800'> <p class='mb-6'>Tired of incorporating your business the old way?</p><p class='mb-6'>We help global business owners, entrepreneurs and professionals like you start a company, hassle-free.</p><p>Our innovative solutions free you from the slow, repetitive and manual incorporation process. So you can focus on what really matters!</p></div>",
      leftClassName: "lg:col-7",
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        wrapper: {
          className: "bbc-banner-image-country pb-10 lg:pb-0"
        },
        src: "/assets/images/hk/".concat(dataJson.banner_image),
        className: "h-full w-full",
        width: 560,
        height: 456,
        priority: true,
        alt: "tech-enabled Hong Kong incorporation service"
      }),
      bgColor: "bg-bbc-gradient-service"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mt-10 lg:mt-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(OffshoreCompanyRegistration/* default */.Z, {
        data: dataJson.dataRegistration
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "bg-bbc-gradient-9",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AnyIndustry, {
        data: dataJson.dataAnyIndustry
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: dataJson.dataOpenBankAccount && typeof dataJson.dataOpenBankAccount === "object" && Object.keys(dataJson.dataOpenBankAccount).length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(StepSlider, {
          data: dataJson.dataOpenBankAccount,
          className: "pt-0 lg:pt-0",
          title: dataJson.dataOpenBankAccount.title,
          imgAlt: dataJson.dataOpenBankAccount.alt
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
      src: "/assets/images/wave/top-wave.png",
      width: 1920,
      height: 125,
      className: "hidden w-full lg:block",
      wrapper: {
        className: "w-full"
      },
      alt: "Wave top"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lg:bg-bbc-package",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container ",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PackagesNews/* default */.Z, {
          data: (data === null || data === void 0 ? void 0 : data.dataPackage) || [],
          dataStatic: dataJson.dataPackage,
          title: "".concat(country === "United Kingdom" ? "UK" : country, " Company Formation Packages")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(RefundGuarantee/* default */.Z, {
          className: "mb-10 pt-6 lg:mb-20 lg:pt-10"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row mb-10 items-center lg:mb-20",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "justify-self-start lg:col-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "h-full",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                text: "Bring Your Next<br/> Business Venture Online",
                className: "bbc-title mb-6 text-center text-bbc-30px text-bbc-brand-800 lg:mb-0 lg:text-left lg:text-bbc-40px"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "lg:col-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "h-full",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
                  src: "https://www.youtube.com/embed/8RkJwKEXKPU?start=2",
                  width: "540",
                  height: "303",
                  frameBorder: "0",
                  title: "Bring your next business venture online",
                  allow: "accelerometer; autoplay;encrypted-media; gyroscope;picture-in-picture",
                  allowFullScreen: true,
                  className: " w-full"
                })
              })
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-10 lg:mb-20",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(WhatMakeUsDifferent/* default */.Z, {
          title: "",
          data: dataJson.dataWhatMakeUsDifferent,
          className: "bg-wmud mb-10 py-[60px]"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mb-10",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
              text: "We make opening the business bank account simple",
              className: "bbc-title mb-6 text-center"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Opening an account with traditional banks is a good starting point if you want to grow your business. But if you\u2019re a startup and your banking needs don\u2019t include premium offerings from high-end providers. A Fintech-based account is a simpler option."
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "row relative mx-auto mt-6 w-full flex-col-reverse items-center p-0 lg:mx-auto lg:mt-10 lg:w-11/12 lg:flex-row",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(CISlider, {
                  dataJson: dataJson,
                  swiper: swiper,
                  screen: screen
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "col-12 right-0 top-0 bottom-0 my-auto flex items-center p-0 lg:col-6 lg:absolute",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "w-full text-center ",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                    src: "/assets/images/hk/company-incorporation/group_business-hk-incorporation.png",
                    width: 478,
                    height: 363,
                    alt: "set up company in Hong Kong with a bank account",
                    className: "w-full",
                    wrapper: {
                      className: "mb-6 w-full lg:mb-10 flex justify-center"
                    }
                  })
                })
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mb-10",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
              as: "h2",
              className: "mb-6 text-center text-3xl font-semibold  text-bbc-brand-800 lg:text-bbc-40px ",
              children: "We simplify your company incorporation"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "m-auto w-full  text-center lg:w-3/5",
              children: "Our streamlined process is broken down into 4 simple steps, purposely designed to expand your confidence as you go."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "row",
              children: ((_dataJson$dataHowItWo = dataJson.dataHowItWorks) === null || _dataJson$dataHowItWo === void 0 ? void 0 : _dataJson$dataHowItWo.length) > 0 && ((_dataJson$dataHowItWo2 = dataJson.dataHowItWorks) === null || _dataJson$dataHowItWo2 === void 0 ? void 0 : _dataJson$dataHowItWo2.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-12 mt-6 lg:col-4 lg:mt-10",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardRegistration, {
                    index: index,
                    item: item
                  })
                }, index);
              }))
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "row items-center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "justify-self-start lg:col-6",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "h-full",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                    text: "Here's what your company looks like in terms of costs",
                    className: "bbc-title text-bbc-30px text-bbc-brand-700"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "hidden lg:inline-block",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
                      as: "a",
                      useRouter: true,
                      href: "/guide-and-tool/hong-kong-cost-planning-tool",
                      variant: "outline",
                      othersClass: "mt-6 ",
                      children: "Try It Now"
                    })
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "lg:col-6",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "h-full text-center lg:text-right",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                    src: "/assets/images/hk/company-incorporation/hk_tool-sg-incorporation.png",
                    width: 448,
                    height: 470,
                    wrapper: {
                      className: "flex justify-center lg:inline-block"
                    },
                    alt: "Hong Kong Tool"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
                    as: "a",
                    useRouter: true,
                    href: "/guide-and-tool/hong-kong-cost-planning-tool",
                    variant: "outline",
                    othersClass: "mt-6 lg:hidden",
                    children: "Try It Now"
                  })]
                })
              })]
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(RequiredDocument/* default */.Z, {
        title: "What documents to prepare?",
        data: dataJson.dataRequiredDocument,
        sectionClassName: "py-10 lg:py-20 mb-10 ",
        backgroundImage: "/assets/images/common/required-documents.png"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(EbookDownload/* default */.Z, {
          title: dataJson.dataEbookDownload.title,
          imgSrc: dataJson.dataEbookDownload.imgSrc,
          hash: dataJson.dataEbookDownload.hash,
          dataForm: dataJson.dataEbookDownload.dataForm,
          wrapper: {
            className: "mb-10 lg:mb-20"
          },
          alt: dataJson.dataEbookDownload.alt,
          form: dataJson.dataEbookDownload.form,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6",
            children: "Not sure about how to start a business? Crush your uncertainty and gain an extra edge with our Hong Kong Incorporation Checklist."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            children: ["Company launching requirements", "Steps and application procedure", "Checklist of business licenses", "Post-registration keynotes"].map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "mb-2 last:mb-0",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(CheckContent/* default */.Z, {
                  data: item
                })
              }, index);
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            text: "Accounting solution for HK Start-ups and SMEs",
            className: "bbc-title mb-10 text-center"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "m-auto w-4/5",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "row",
              children: dataJson.dataAccountingSolution.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "col-12 text-center lg:col-3",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                    src: "/assets/icons/".concat(item.icon),
                    alt: item.title,
                    width: 48,
                    height: 48,
                    className: "h-12 w-12",
                    wrapper: {
                      className: "bg-bbc-brand-100 rounded-3xl p-4 inline-block mb-3"
                    }
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: " font-medium",
                    children: item.title
                  })]
                }, index);
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-10 text-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
              as: "a",
              useRouter: true,
              href: "/accounting-and-auditing#caculator-price",
              children: "Get a quote"
            })
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " absolute hidden h-1/2 w-full md:block lg:bg-bbc-package"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container relative  z-10 pt-10 lg:pt-20",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "m-auto lg:col-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormCountries/* default */.Z, {
            title: dataJson.dataFormContact.title,
            description: dataJson.dataFormContact.description,
            country_id: 98
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/wave/bottom-wave.png",
        width: 1920,
        height: 140,
        className: "hidden  w-full lg:block",
        wrapper: {
          className: "absolute w-full top-1/2 hidden md:block"
        },
        alt: "Wave bottom"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:col-10 lg:m-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
            data: dataJson.dataFaqs,
            title: dataJson.dataFaqs.title,
            description: dataJson.dataFaqs.description,
            defaultActiveKey: dataJson.dataFaqs.defaultActiveKey,
            multipleOpen: dataJson.dataFaqs.multipleOpen
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
          children: "Industry News & Insights"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsSlider, {
            data: data
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormNewsletter/* default */.Z, {
        bgColor: "bg-bbc-gradient-9"
      })
    })]
  });
};

/* harmony default export */ var company_incorporation = (HkCompanyIncorporation);
;// CONCATENATED MODULE: ./pages/hk/company-incorporation/data.json
var data_namespaceObject = JSON.parse('{"country":"Hong Kong","banner_image":"company-incorporation/banner-hk-incorporation.png","breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Company formation ","uri":"/company-formation"}],"dataTrustpilot":{"content":{"button_placeholder":false,"benefits":["Company registration in 2 days","Open bank account online","Dedicated support","Digital platform to set up and manage"],"see_package":"See available package","see_package_id":"PriceTable"}},"dataAnyIndustry":[{"icon":"ecommerce.svg","title":"E-commerce","description":"Hong Kong maintains a great logistic infrastructure and a scalable digital payment foundation that\'s open to change. With a total market value of $3.7billion, it\'s more than just promising to capitalize on this lucrative industry.","link":{"href":"/hk/guide-and-tool/hong-kong-ecommerce-guide","text":"Hong Kong E-commerce Guide"}},{"icon":"healthcare.svg","title":"Healthcare","description":"Healthcare is booming in Hong Kong. According to Food and Health Bureau, the total public and private health expenditure in Hong Kong alone controls 6.8% of the country\'s GDP."},{"icon":"user-headset.svg","title":"Cosmetics & Personal Care","description":"Beauty products have been seeing consistent growth in demand in Hong Kong. In 2019, imports of cosmetic and personal care items amounted to over HK$47billion in 2019, an attractive incentive for those that want to enter the beauty business."},{"icon":"two-bags.svg","title":"Retail","description":"Shopping is one of the most common phenomena for the large population of Hong Kong. Within the maze-like structure of Hong Kong\'s urban jungle are over 63,000 sprawling shopping malls and retail establishments of all sizes."},{"icon":"maintenance.svg","title":"Technology","description":"When it comes to being a central hub for IT and technology development, Hong Kong is a name that can now rival even Guangdong and Shenzen. Together, these major tech regions form the world\'s second largest technology cluster according to Global Innovation Index 2020."},{"icon":"plane.svg","title":"Travel & Hospitality","description":"Tourism is one of the main economic pillars that keeps the lifeblood of this bustling state running. In 2018, around 4.5% of the country\'s GDP was from this industry alone, and along with it are around 257,000 employed professionals."},{"icon":"column-chart.svg","title":"Finances","description":"A solid banking landscape, deep capital market and asset management are what define Hong Kong\'s place as a premium spot for investors worldwide. This is further supported by its robust ranking amongst the top international financial centres on GFCI."},{"icon":"education.svg","title":"Education","description":"Considered an academic mecca of the Asia region, Hong Kong has been an industry-leading figure in education since the turn of the century. Parents spend on average +$130,000 on their kids\' educational well-being which includes schooling, transportation and accommodation."},{"icon":"hand-money.svg","title":"Trading","description":"Hong Kong develops a conductive trading environment that encourage freedom of trade and growth opportunities for businesses. With total merchandise trade value of HK$830,163 million, its trading industry is one of the most active in the world.","link":{"href":"/hk/guide-and-tool/hong-kong-trading-guide","text":"Hong Kong Trading Guide"}}],"dataRegistration":{"country":" Offshore Company Registration in Hong Kong","title":"How to register your company in Hong Kong","data_left":["Offering complete ownership to foreigners","Profit tax rate ranges from low 8.25% - 16.5%","Foreign sourced income is exempted from corporate income tax","No sales tax, import, capital gain tax or tax on dividends and interest","No withholding tax on dividend distributions and interest payments made out to a resident or non-resident","Straightforward gateway to Mainland China and Asian markets","The world’s third easiest country to do business with in 2020 by World Bank"],"data_right":[{"title":"Hong Kong Limited Company Features","list_regulation":[{"title":"At least one director/one shareholder","icon":"director-shareholder.svg"},{"title":"Local registered address","icon":"location-user.svg"},{"title":"Local company secretary","icon":"bank.svg"},{"title":"Bearer shares are not allowed","icon":"permitted.svg"},{"title":"No requirement for paid-up capital","icon":"wallet.svg"}]}]},"dataOpenBankAccount":{"title":"How to register your company in Hong Kong","image":"/assets/images/offshore/country/bvi/bank_account-bvi.png","alt":"steps to register a company in Hong Kong","steps":[{"index":"Step 1: ","titleStep":"Select company name and types","description":"<p>Note that there are some naming guidelines that you have to follow according to statutory law. Each name must have an ending word that represents its business nature.</p><p>In the case of a private limited company, the word \\"Limited\\" must be the last word to appear in the name. For an English-named company in Hong Kong, the abbreviation \\"Ltd\\" is not allowed and it must use \\"Limited\\" in full.</p><p>Got a name for your business? Run it through our <a href=\'/hk/guide-and-tool/hong-kong-company-name-check\' target=\'_blank\' rel=\'noopener\' class=\'text-bbc-brand-500 font-medium\'>Name Check Tool</a> to see if it is an eligible one.</p>"},{"index":"Step 2:","titleStep":"Submit application","description":"You need necessary information on key personnel ( e.g. directors & shareholders) to include them along with your chosen name to the Companies Registrar (CR)."},{"index":"Step 3:","titleStep":"Apply for a business license","description":"<p>You can operate most business activities freely in Hong Kong without any constraint, but some do require the extra step of acquiring a business license first.</p><p>The following is a non-exhaustive list of businesses that require license/permit:</p><ul><li>An employment agency</li><li>A travel agency</li><li>A restaurant</li><li>An education business</li><li>Financial &amp; Insurance services</li></ul>"},{"index":"Step 4:","titleStep":"Open a bank account","description":"<p>The next step is to open a bank account. Local banks like DBS, Hang Seng, and OCBC are some of the most prestigious places to open a business account at.</p><p>More tech-based alternatives also exist in form of neobanks like Neat to make the process even faster.</p>"},{"index":"Step 5:","titleStep":"Check your annual compliance","description":"As Hong Kong is a highly prolific jurisdiction for international businesses, the legal ceiling is relatively higher compared to most other places. This is why commercial entities here generally have to abide by a higher degree of corporate compliance when doing annual return filing, maintaining their registered office and records-keeping."}]},"dataPackage":{"listPackage":[{"id":2,"country_id":98,"country_name":"Hong Kong","checkName":true,"kind":"basic","price":799,"banner":"","content":[{"subTitle":"Corporate secretary service:","listContent":[{"text":"Name availability check","checkName":true},{"text":"Document preparation and filing"},{"text":"Company Setup within 24 hrs"},{"text":"Digital corporate documents"}]},{"subTitle":"All mandatory legal stuff:","listContent":[{"text":"01-year Company Secretary"},{"text":"01-year Local Registered Address"},{"text":"All Government fees in 01 year"},{"text":"Significant Controller Register with Designated Representative"}]},{"subTitle":"<span class=\'pr-2\'>Free Support to open a Neat account</span> <span class=\'w-16 h-16 text-right\'><img src=\'/assets/images/hk/company-incorporation/label_neat-hk-incorporation.png\' class=\'float-right\' width=\'43\' height=\'43\'  loading=\'lazy\' alt=\'logo\' /></span>"},{"subTitle":"<span class=\'pr-2\'>Some extras from us with love </span> <span class=\'w-12 h-12\'><img src=\'/assets/images/hk/company-incorporation/label_sale-hk-incorporation.png\' class=\'float-right\' width=\'43\' height=\'46\' loading=\'lazy\' alt=\'logo\' /></span>","listContent":[{"text":"Mail scanning service"},{"text":"One set of documents certified by CPA"},{"text":"Free 1st-year PTR filing"}]}],"notes":["* All-in renewal fee at US$739"]},{"id":3,"checkName":true,"kind":"standard","price":1199,"content":[{"subTitle":"Everything in Basic package"},{"subTitle":"Open The Bank Account","listContent":[{"text":"One-time fee for application of one bank"},{"text":"Consulting on the preparation of your chosen bank’s required documents"},{"text":"Preparing certified corporate documents for a bank (if needed)"},{"text":"Making appointment with your chosen bank in the <a href=\'/hk/open-bank-account#banking_options\' class=\'font-medium text-bbc-brand-500 \'>supported list</a>"}]}],"notes":[]},{"id":5,"kind":"premium","price":1499,"banner":"","checkName":true,"content":[{"subTitle":"Everything in Standard package"},{"subTitle":"Premium The Banking Support","listContent":[{"text":"One-time fee for application of up to 5 banks OR till account opened successfully, whichever comes first"},{"text":"Consulting on your suitable alternative banks if you fail your first application"},{"text":"Ability to open a bank account remotely"},{"text":"Fast responsiveness even on weekends"},{"text":"Frequent updates on the bank account opening process"}]}],"notes":[]}]},"dataWhatMakeUsDifferent":[{"title":"Streamlined process","description":"Start at your own pace. And reduce waiting time for back-and-forth email communication.","img_src":"/assets/images/common/process-wmud.png"},{"title":"E-signature","description":"Collaborate with your partner more easily. Less paperwork, more efficiency.","img_src":"/assets/images/common/e_signature-wmud.png"},{"title":"Digitized KYC","description":"Standardized form & organizational chart to let you control and declare your information effortlessly.","img_src":"/assets/images/common/kyc-wmud.png"},{"title":"Centralized management portal","description":"24/7 access to company documents on high-security cloud infrastructure. And no worry about key compliance deadlines with the auto reminder.","img_src":"/assets/images/common/portal-wmud.png"}],"dataEmi":[{"logoImg":{"src":"/assets/images/hk/company-incorporation/neat-hk-incorporation.png","width":55,"height":16,"alt":"neat logo"},"description1":"<p class=\'mb-2\'>A Neat account covers all your business financial needs</p>","checklist":["Multi-currency business account","Fast transfers with competitive fees"],"description2":"<p class=\'mt-2\'>Incorporate with us and receive HKD$500 credited to your Neat account!</p>","btnLink":"https://www.neatcommerce.com/marketplace/bbcincorp/","btnName":"Learn More"},{"logoImg":{"src":"/assets/images/hk/company-incorporation/airwallex-hk-incorporation.png","width":140,"height":41,"alt":"airwallex logo"},"description1":"<p class=\'mb-6\'>Airwallex offers a streamlined solution for your business finances.</p><p>Sign up to receive zero conversion fee for the first HKD$100,000 or equivalent in other currencies.</p>","btnLink":"https://airwallex.grsm.io/bbcincorp","btnName":"Sign Up"},{"logoImg":{"src":"/assets/images/hk/company-incorporation/instarem-hk-incorporation.png","width":83,"height":42,"alt":"instarem"},"description1":"Instarem simplifies business payment globally","checklist":["Fast multi-currency payments and competitive fees","Same-day transfer and real-time notification"],"btnLink":"/hk/announcements/bbcincorp-x-instarem","btnName":"Learn More"}],"openBusinessAccount":true,"dataHowItWorks":[{"title":"Create your orders","content":"Enter our online order platform for an easy onboarding experience and tailor your orders. We have different packages of Hong Kong offshore company formation and additional services that suit your goals. During this process, we also provide free consulting to help you set up the right company structure per your need."},{"title":"Make payment","content":"You can settle payment for services via flexible payment options including debit/credit card of Visa, Master, Amex or Bank Transfer. After you complete payments, we will provide you a with checklist of required information for Hong Kong company registration."},{"title":"Collect and verify KYC documents","content":"Once we\'ve received your payment, our customer service will contact you to process the necessary paperwork. We\'ll guide you to properly prepare documents for incorporation in Hong Kong via KYC online form. You can also access our digital Client Portal to proceed with the incorporation steps and keep track of the process anytime, anywhere. "},{"title":"Finish the company registration","content":"The electronic documents are ready after 2 working days of company formation, and it takes 3-7 days to courier the original kit."}],"dataRequiredDocument":{"title":"What documents to prepare","button":{"type":"talk-to","text":"Talk To Our Expert"},"content":[{"title":"","listContent":[{"text":"Passport of all shareholders/directors","content":[]},{"text":"Address proof of all shareholders/ directors i.e. identity card, bank statement, driving license, utility bill","content":[]},{"text":"10-second selfie video of each member holding his/her passport, and speaking their name, passport number, and the service you need","content":[]}]}]},"dataEbookDownload":{"title":"Incorporation checklist download","imgSrc":{"src":"/assets/images/hk/company-incorporation/ebook_banner-hk-incorporation.png","alt":"ebook Hong Kong incorporation checklist","width":300,"height":300},"imgLeft":{"src":"/assets/images/hk/common/checklist-hk-common.png"},"triggerName":"Incorporation Checklist - Hong Kong","apiLink":"api/portal/contact_form/ebook","contactFromId":34,"dataForm":"checklist_hk"},"dataAccountingSolution":[{"icon":"hand-money.svg","title":"Economic package with Multi-tier pricing"},{"icon":"user-cloud.svg","title":"Xero cloud accounting"},{"icon":"three-human.svg","title":"Efficient communication"},{"icon":"title.svg","title":"Local Certified Experts"}],"dataFormContact":{"title":"Need more help to set up a business in Hong Kong?","description":"Just get in touch with us. We typically respond within 2 hrs."},"dataFaqs":{"activeTab":0,"data":[{"name":" Incorporation ","faqs":[{"name":"Can foreigners open a company in Hong Kong?","content":"<p>Yes. A Foreigner is allowed to take up 100% ownership in a Hong Kong company and can be the sole director and shareholder.\\n\\n</p>"},{"name":"If my company operates business totally outside of Hong Kong, must I do the accounting and auditing report?","content":"<p>All Hong Kong companies are required to file annual returns with the Companies Registry and the Inland Revenue Department. The accounting and auditing reports are included in the annual compliance obligations, regardless of where the business activities take place.</p>"},{"name":"Do we have to present in Hong Kong to incorporate?","content":"<p>The company formation in Hong Kong can be done remotely with a professional service provider like BBCIncorp. You can have the digital corporate documents after a single day of registration.</p>"},{"name":"How much does it cost for Hong Kong company registration?","content":"<p>The cost for incorporating your business can be various and depend greatly on your business types, capital structures, industries, etc.</p><p>Some businesses need significant initial capital to start, while others such as micro-businesses and home-based companies have lower financial entry barriers.</p><p>One common way to estimate your incorporation cost is by drafting a business plan. Within your plan, the financial section should show your approximate revenue, profit, and expenses.</p><p>There are other ways to estimate your finances as well, such as our <a class=\'text-bbc-primary\' href=\'/hk/guide-and-tool/hong-kong-cost-planning-tool\'>Hong Kong Cost Planning Tool</a>. The tool will help you break down all initial costs of your business, so you know how much capital you should prepare when incorporating.</p>"},{"name":"Do I need a Corporate Secretary?","content":"<p>Yes. Appointing a company secretary is a legal obligation if you wish to register a company in Hong Kong.</p>"},{"name":"How long does it take to register a company?","content":"<p>It normally takes only 1 working day for e-filing and registration.</p>"},{"name":"What are the initial requirements to register a Hong Kong company?","content":"<ul><li>Minimum one director and one shareholder, which can be the same person.</li><li>A local registered address in Hong Kong.</li><li>A local company secretary, which can be a Hong Kong resident (above 18 years old) or a Hong Kong-registered company.</li></ul>"}]},{"name":"Corporate structure/capital","faqs":[{"name":"What is the minimum director/shareholder of a Hong Kong private company?","content":"<p>A minimum of one director and one shareholder are required. Moreover, at least one natural person must be appointed as a director. Corporate directors are only approved with specific conditions.</p><p>A person can be the sole director and shareholder of a company. But the sole director cannot be the company secretary of the same company.</p>"},{"name":"Are registers of directors/shareholders disclosed to the public?","content":"<p>Yes, information of directors and shareholders must be filed for registration with the Company Registrar. The company is also responsible for identifying the company’s significant beneficial owners and has to register with the Registrar.\\n\\n</p>"},{"name":"What is the requirement for minimum registered capital?","content":"<p>There is no required minimum registered capital to open a Hong Kong private company, and the standard is HK$10,000.\\n\\n</p>"},{"name":"What classes of shares are allowed to be issued by a private company?","content":"<p>Ordinary (registered shares), preferred shares, voting and non-voting shares, shares with no par value, redeemable shares, and shares with special voting rights.\\n\\n</p>"}]},{"name":"Taxation","faqs":[{"name":"Which taxes does my Hong Kong company have to pay?","content":"<p>As Capital gains, Dividends, Interest incomes, VAT and Withholdings are tax-exempted in Hong Kong, a Hong Kong company needs to pay only corporate profits tax to the government.</p><p>The Corporate profits tax rate in Hong Kong is 8.25% for the first 2 million HKD of assessable incomes and 16.5% for the remainder.</p>"},{"name":"What is an offshore claim? How can I know if I am eligible for an offshore claim in Hong Kong?","content":"<p>An offshore claim is a process in which you prove your profits derived from sources outside of Hong Kong territory and is non-taxable in Hong Kong.</p><p>To be eligible for an offshore claim in Hong Kong, you need to meet the requirements from Inland Revenue Department. Generally, the requirements include, but are not limited to:</p><ul><li>Having no clients in Hong Kong</li><li>Having no physical office and staff in Hong Kong</li><li>Having no web hosting in Hong Kong</li><li>Having no services, sales, and business performed in Hong Kong</li><li>Having no warehousing and fulfilment in Hong Kong</li></ul><p>Our Hong Kong <a href=\'/hk/guide-and-tool/hong-kong-offshore-claim-tool\' target=\'_blank\' rel=\'nofollow\'>Offshore Claim Tool</a> can assist you to determine the tax status of your income types to ascertain your eligibility for making an offshore claim.</p>"},{"name":"How can I get Offshore Claim (tax-exempted status) for my Hong Kong company?","content":"<p>You can apply for Offshore status with Hong Kong Inland Revenue Department (IRD) as soon as you file an annual tax return for the first time. The process might take several months as IRD will raise questions for directors during the investigation. The Offshore Claim can be effective in 3 or 5 years; however, annual auditing is always compulsory.</p>"}]},{"name":"Post-incorporation","faqs":[{"name":"Which businesses are required licensing in Hong Kong?","content":"<p>In Hong Kong, licenses or permits are required for an employment agency, event-related activities, travel agency, education, restaurant, and retail shop, if the business is operated in Hong Kong.</p><p>A license is mandatory for a Hong Kong-based company with an insurance agency and financial services, regardless of where you run the business.</p>"},{"name":"What are the required conditions to maintain a private limited company in Hong Kong?","content":"<ul><li>Maintaining one director, one shareholder;</li><li>Maintaining local registered address and local company secretary;</li><li>Renewal business registration certificate;</li><li>Annual return filing;</li><li>Tax return filing with audited financial statements.</li></ul>"},{"name":"What are the best banks in Hong Kong?","content":"<p>Hong Kong is deemed among the most reputed financial centers in the world. There might be a long list of premium banks in Hong Kong that make you quite confused, some of the best banks in Hong Kong you should put into consideration list include HSBC, DBS, Citibank, Hang Seng bank, etc.</p><p><a target=\'_blank\' rel=\'nofollow\' href=\'/hk/open-bank-account\'>Explore more options</a></p>"}]}]}}');
;// CONCATENATED MODULE: ./pages/hk/company-incorporation/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "hk",
    navLight: true,
    page: data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(company_incorporation, {
      data: data,
      dataJson: data_namespaceObject
    })
  });
}

/***/ }),

/***/ 75395:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hk/company-incorporation",
      function () {
        return __webpack_require__(46570);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 159:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,8352,4868,4090,9738,7447,2314,9156,975,913,2888,179], function() { return __webpack_exec__(75395); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);